import BaseAPIClient from './base/BaseAPIClient';

export default class BillingsClient extends BaseAPIClient {
  forgive(paymentId) {
    return this._post('v2/billing/invoice/forgive', {
      paymentId
    });
  }

  reinvoice(paymentId) {
    return this._post('v2/billing/invoice/reinvoice', {
      paymentId
    });
  }
}
